import { RouteType } from "types/RouteType";
import dashboardRoute from "./Dashboard/AccountingDashboard.Route";
import purchasesRoute from "./Purchases/Purchases.Route";
import salesRoute from "./Sales/Sales.Route";
import holidayScheduleRoute from "./HolidaySchedule/holidaySchedule.Route";
import poConversionRoute from "./po-conversion/POConversion.Route";
import invoiceConversionRoute from "./invoice-conversion/InvoiceConversion.Route";
import invoiceDetailRoute from "./invoice-detail/InvoiceDetail.Route";
import chartOfAccountsRoute from "./ChartOfAccounts/ChartOfAccounts.Route";
import journalEntriesRoute from "./JournalEntries/JournalEntries.Route";
import trialBalanceRoute from "./Reports/TrialBalance.Route";
import jobCostingRoute from "./JobCosting/JobCosting.Route";
import productionCostsRoute from "./ProductionCosts/ProductionCosts.Route";
import financialReportsRoute from "./Reports/FinancialReports/FinancialReports.Route";
import taxLookupRoute from "./tax-lookup/TaxLookup.Route";
import plantOverviewRoute from "./PlantOverview/PlantOverview.Route";
import purchaseOrdersRoute from "./PurchaseOrders/PurchaseOrders.Route";
import taskWorkflowRoute from "./TaskWorkflow/TaskWorkflow.Route";
import invoicesRoute from "./Invoices/Invoices.Route";
import accountsPayableRoute from "./AccountsPayable/AccountsPayable.Route";
import accountsReceivableRoute from "./AccountsReceivable/AccountsReceivable.Route";
import freightMatchingRoute from "./FreightMatching/FreightMatching.Route";
import assetTransactionsRoute from "./AssetTransactions/AssetTransactions.Route";
import checkPrintingRoute from "./CheckPrinting/CheckPrinting.Route";
import checkTemplateDesignerRoute from "./CheckTemplateDesigner/CheckTemplateDesigner.Route";
import recurringTransactionsRoute from "./RecurringTransactions/RecurringTransactions.Route";
import fiscalPeriodsRoute from "./FiscalPeriods/FiscalPeriods.Route";
import reportBuilderRoute from "./Reports/ReportBuilder/ReportBuilder.Route";
import generalLedgerRoute from "./GeneralLedger/GeneralLedger.Route";
import reconciliationRoute from "./Reconciliation/Reconciliation.Route";
import { accountingHubRoute } from "@intrasync/accounting";

const accountingRoutesList: RouteType[] = [
  // AccountingHub route from @intrasync/accounting (name "Accounting", path "/accounting")
  accountingHubRoute as unknown as RouteType,
  dashboardRoute,
  purchasesRoute,
  salesRoute,
  chartOfAccountsRoute,
  journalEntriesRoute,
  jobCostingRoute,
  productionCostsRoute,
  trialBalanceRoute,
  financialReportsRoute,
  poConversionRoute,
  invoiceConversionRoute,
  invoiceDetailRoute,
  taxLookupRoute,
  plantOverviewRoute,
  purchaseOrdersRoute,
  taskWorkflowRoute,
  invoicesRoute,
  accountsPayableRoute,
  accountsReceivableRoute,
  freightMatchingRoute,
  assetTransactionsRoute,
  checkPrintingRoute,
  checkTemplateDesignerRoute,
  recurringTransactionsRoute,
  fiscalPeriodsRoute,
  reportBuilderRoute,
  generalLedgerRoute,
  reconciliationRoute,
  ...holidayScheduleRoute,
];

export default accountingRoutesList;
